import { InjectionToken } from '@angular/core';

export const FLOORI_LAYOUTS = new InjectionToken('FLOORI_LAYOUTS');

export const FLOORI_CONTEXT_ID = new InjectionToken('FLOORI_CONTEXT_ID');

export const FLOORI_TRACKING_PROVIDER = new InjectionToken('FLOORI_INTERACTION_PROVIDER');
